import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { UntypedFormBuilder, Validators, UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { FileInput, FileValidator } from 'ngx-custom-material-file-input';
import { DialogService } from '../../services/dialog.service';
import { UtilsService } from '../../services/utils.service';
import { CaptchaComponent } from '../captcha/captcha.component';
import { EmailVerificationComponent } from '../email-verification/email-verification.component';
import { CaptchaVerificationDto } from '@shared/dtos/captcha-verification.dto';
import { EmailVerificationDto } from '@shared/dtos/email-verification.dto';

@Component({
  selector: 'form-form-send',
  templateUrl: './form-send.component.html',
  styleUrls: ['./form-send.component.scss'],
})
export class FormSendComponent implements OnInit {
  @Input() mailAvailable: boolean = false;
  @Input() emailVerification: boolean = true;
  @Input() overrideSendMailWarning?: string;
  @Input() overrideSendMailAddress?: string;

  @Output() download: EventEmitter<{ attachment: boolean }> = new EventEmitter<{
    attachment: boolean;
  }>();
  @Output() sendForm: EventEmitter<{
    pdf: Blob;
    captcha: CaptchaVerificationDto;
    emailVerification: EmailVerificationDto;
  }> = new EventEmitter<{ pdf: Blob; captcha: CaptchaVerificationDto; emailVerification: EmailVerificationDto }>();
  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();
  @ViewChild(CaptchaComponent) captchaComponent: CaptchaComponent;
  @ViewChild(EmailVerificationComponent) emailVerificationComponent: EmailVerificationComponent;

  formGroup: UntypedFormGroup;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private dialogService: DialogService,
    private translateService: TranslateService,
    private utilsService: UtilsService
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  downloadPdf(event: { attachment: boolean }): void {
    this.download.next(event);
  }

  initForm(): void {
    const group: any = {
      signedPDF: [
        null,
        [
          Validators.required,
          // Max 6MB
          FileValidator.maxContentSize(6291456),
        ],
      ],
      captchaVerification: [null, [Validators.required]],
    };

    if (this.emailVerification) {
      group.emailVerification = [null, [Validators.required]];
    }
    this.formGroup = this.formBuilder.group(group);
  }

  async onFormSend(): Promise<void> {
    if (this.formGroup.valid) {
      const pdfBlob: Blob = (this.formGroup.value.signedPDF as FileInput)
        .files[0];

      const captchaVerification: CaptchaVerificationDto =
        this.formGroup.value.captchaVerification;
      const emailVerification: EmailVerificationDto =
        this.formGroup.value.emailVerification;

      const isDocumentSigned = await this.dialogService.confirm({
        message: this.translateService.instant(
          'components.form-send.is-document-signed'
        ),
        width: '400px',
      });

      
      const result: any = { pdf: pdfBlob, captcha: captchaVerification };
      if (this.emailVerification) {
        result.emailVerification = emailVerification;
      }

      if (isDocumentSigned) {
        this.sendForm.next(result);
        this.captchaComponent.loadCaptcha();
      }
    } else {
      this.utilsService.markFormGroupTouched(this.formGroup);
    }
  }

  onCancel(): void {
    this.cancel.next();
  }
}
